import Head from "next/head"
import { useTranslations } from "use-intl"
import { fetchTranslations } from "utils"
import { generateMetaTags } from "utils/generateMetaTags"

export default function RepostedJobs() {
  const t = useTranslations("RepostedJobs")
  return (
    <div>
      <Head>
        <title>{t("meta.title")} | SeasonalJobs.dol.gov</title>
        <meta name="description" content={t("meta.description")} />
        {generateMetaTags({
          title: t("meta.title"),
          description: t("meta.description"),
        })}
      </Head>
      <main id="main-content" className="grid-container sm:px-10 pt-12 pb-20">
        <div className="mb-12 mt-6 flex flex-col ">
          <h1 className="font-bold text-4xl xl:text-5xl font-serif">
            {t("heading")}
          </h1>
          <div
            className="my-6 text-paragraph with-links"
            dangerouslySetInnerHTML={{ __html: t.raw("description") }}
          />
        </div>
      </main>
    </div>
  )
}

export async function getServerSideProps({ locale }) {
  const repostedJobs = await fetchTranslations({
    locale,
    title: "RepostedJobs",
  })

  return {
    props: {
      messages: {
        ...repostedJobs,
      },
    },
  }
}
